"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.promo-strip-extended"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.call4-selling"));

var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.inline-components"));

var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));

var _PromoBar = _interopRequireDefault(require("../../PromoBar"));

var _bannerUtils = require("../../bannerUtils");

require("./FullPic.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FullPic = _ref => {
  let {
    components,
    idBanner,
    mainTaggingInfo,
    bannerMinHeight,
    widthUnit,
    width
  } = _ref;
  let button2TaggingInfo = mainTaggingInfo;

  if (components && components['Button-2'] && (components['Button-2'].link || components['Button-2'].onClick)) {
    if (components['Button-2'].taggingInfo) {
      button2TaggingInfo = components['Button-2'].taggingInfo;
    }
  } // Tratamiento fondo del bannerDistriHome


  const {
    whereDiv2Fit,
    cssbgColor
  } = (0, _bannerUtils.generateBgAndProperties)(idBanner, components, 'FullPic');
  const backgroundImage = components && components['BgImage-1'];
  const {
    picMobile
  } = backgroundImage;
  const cssHeight = `fullPic--${bannerMinHeight}`;
  const widthProcessed = (0, _bannerUtils.handleContentWidth)(widthUnit, width);
  let inlineStyles = {};
  let columnCss = 'col-xs-12 col-sm-6';

  if (typeof widthProcessed === 'object') {
    inlineStyles = widthProcessed;
    columnCss = 'info';
  }

  if (typeof widthProcessed === 'string') {
    columnCss = `${widthProcessed}`;
    inlineStyles = {};
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: idBanner,
    className: `bannerDistriHome fullPic ${cssHeight} banner_bgColor${cssbgColor}`,
    children: [components['PromoStripExtended-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "promostrip container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        components: components['PromoStripExtended-1']
      })
    }), whereDiv2Fit !== 'container' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `banner_shade  banner_shade_left banner_shade_left${cssbgColor}`
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `banner_shade banner_shade_right banner_shade_right${cssbgColor}`
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "container fullPicContainer bannerDistriHome--bgcontain bannerDistriHome--bgleft",
      children: [whereDiv2Fit === 'container' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `banner_shade  banner_shade_left banner_shade_left${cssbgColor}`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `banner_shade banner_shade_right banner_shade_right${cssbgColor}`
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "row direction-rtl precontactDesktop ",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `contactDesktop ${columnCss}`,
          style: inlineStyles,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "contactDesktop--content direction-ltr",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents4.default, {
              className: "inlineComponents",
              justify: "left",
              children: [components['Button-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['Button-2']), {}, {
                taggingInfo: button2TaggingInfo
              })), components['Call4Selling-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['Call4Selling-1']), {}, {
                taggingInfo: mainTaggingInfo
              }))]
            }), components['Call4Selling-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['Call4Selling-2']), {}, {
              taggingInfo: mainTaggingInfo,
              className: "Call4Selling-2"
            }))]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "mobilePic",
        src: picMobile.src,
        alt: "content"
      }), components['CustomLink-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        link: components['CustomLink-1'].link,
        isBlockElement: true,
        taggingInfo: mainTaggingInfo
      })]
    }), components['PromoBar-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PromoBar.default, _objectSpread({}, components['PromoBar-1']))]
  });
};

var _default = FullPic;
exports.default = _default;

//# sourceMappingURL=index.js.map